import { render, staticRenderFns } from "./ProfileAccountSettingHeader.vue?vue&type=template&id=166830fb&scoped=true"
import script from "./ProfileAccountSettingHeader.vue?vue&type=script&lang=js"
export * from "./ProfileAccountSettingHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileAccountSettingHeader.vue?vue&type=style&index=0&id=166830fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166830fb",
  null
  
)

export default component.exports